(() => {
  if (!customElements.get("search-drawer")) {
    class e extends HTMLElement {
      static SELECTORS=[ "[data-product-grid]", "[data-suggestions]", "[data-collections]", "[data-pages]" ];
      static DEBOUNCE_DELAY=200;
      static FETCH_TIMEOUT=5e3;
      constructor() {
        super(), this.initializeProperties(), this.bindMethods(), this.attachEventListeners(), 
        this.setupLoadingSpinnerReset(), this.init();
      }
      initializeProperties() {
        this.originalElements = new Map, this.timeout = null, this.abortController = null, 
        this.toggle = document.querySelector("input#SearchDrawer"), this.form = this.querySelector("form"), 
        this.input = this.form?.querySelector('input[name="q"]'), this.clearButtons = this.querySelectorAll("[data-clear]"), 
        this.contentContainer = this.querySelector(".header-search__content[data-content]"), 
        this.form && this.input || console.warn("SearchDrawer: Required form elements not found");
      }
      bindMethods() {
        this.handleToggle = this.handleToggle.bind(this), this.handleFormReset = this.handleFormReset.bind(this), 
        this.handleFormSubmit = this.handleFormSubmit.bind(this), this.handleInput = this.handleInput.bind(this), 
        this.handleFocus = this.handleFocus.bind(this), this.handleBlur = this.handleBlur.bind(this), 
        this.handleClear = this.handleClear.bind(this), this.performSearch = this.performSearch.bind(this), 
        this.reset = this.reset.bind(this);
      }
      attachEventListeners() {
        this.toggle?.addEventListener("change", this.handleToggle), this.form?.addEventListener("reset", this.handleFormReset), 
        this.form?.addEventListener("submit", this.handleFormSubmit), this.input?.addEventListener("input", this.handleInput), 
        this.input?.addEventListener("focus", this.handleFocus), this.input?.addEventListener("blur", this.handleBlur), 
        this.clearButtons?.forEach(e => {
          e.addEventListener("click", this.handleClear);
        });
      }
      handleToggle(e) {
        e.target.checked ? requestAnimationFrame(() => {
          this.input?.focus(), this.updateClearButtonVisibility();
        }) : this.reset();
      }
      handleFormReset() {
        requestAnimationFrame(() => {
          this.updateClearButtonVisibility(), this.performSearchImmediate();
        });
      }
      handleFormSubmit(e) {
        this.getSearchQuery().trim() || e.preventDefault();
      }
      handleInput(e) {
        this.updateClearButtonVisibility(), this.performSearchDebounced(e);
      }
      handleFocus(e) {
        this.contentContainer.classList.add("tablet:pb-[55vh]");
      }
      handleBlur(e) {
        this.contentContainer.classList.remove("tablet:pb-[55vh]");
      }
      handleClear(e) {
        e.preventDefault(), e.stopPropagation(), this.input && (this.input.value = "", this.input.focus()), 
        this.updateClearButtonVisibility(), this.restoreOriginalElements();
      }
      updateClearButtonVisibility() {
        if (!this.clearButtons || 0 === this.clearButtons.length) return;
        const e = this.getSearchQuery().length > 0;
        this.clearButtons.forEach(t => {
          e ? (t.classList.remove("opacity-0", "pointer-events-none"), t.classList.add("pointer-events-auto")) : (t.classList.add("opacity-0", "pointer-events-none"), 
          t.classList.remove("pointer-events-auto"));
        });
      }
      async performSearch(e = null, t = "search-drawer") {
        e && (e.preventDefault(), e.stopPropagation());
        const s = this.getSearchQuery();
        if (!s) return void this.restoreOriginalElements();
        this.abortController && this.abortController.abort(), this.abortController = new AbortController;
        const {signal: i} = this.abortController;
        try {
          const e = await this.fetchSearchResults(s, t, i), r = this.parseResponse(e, t);
          r && this.updateResults(r);
        } catch (e) {
          this.handleSearchError(e);
        }
      }
      getSearchQuery() {
        return this.form?.q?.value?.trim() || "";
      }
      async fetchSearchResults(t, s, i) {
        encodeURIComponent(t);
        const r = `${window.Shopify?.routes?.root || "/"}search/suggest?${new URLSearchParams({
          q: t,
          "resources[type]": "query,product,collection,page,article",
          "resources[options][unavailable_products]": "last",
          "resources[limit_scope]": "each",
          "resources[limit]": "12",
          section_id: s
        })}`, n = setTimeout(() => {
          i.aborted || this.abortController.abort();
        }, e.FETCH_TIMEOUT);
        try {
          const e = await fetch(r, {
            signal: i
          });
          if (clearTimeout(n), !e.ok) throw new Error(`HTTP ${e.status}: ${e.statusText}`);
          return await e.text();
        } catch (e) {
          throw clearTimeout(n), e;
        }
      }
      parseResponse(e, t) {
        try {
          const s = new DOMParser;
          return s.parseFromString(e, "text/html").querySelector(`#shopify-section-${t}`);
        } catch (e) {
          return console.error("SearchDrawer: Failed to parse response", e), null;
        }
      }
      updateResults(t) {
        e.SELECTORS.forEach(e => {
          const s = this.querySelectorAll(e), i = "[data-suggestions]" !== e || t.querySelector(e)?.children.length ? t.querySelector(e) : this.originalElements.get(e) || "";
          i && (s.forEach(e => {
            e && (e.innerHTML = i.innerHTML);
          }), "[data-suggestions]" === e && this.attachSuggestionListeners());
        });
      }
      handleSearchError(e) {
        "AbortError" === e.name || e.message?.includes("417") || (console.error("SearchDrawer: Search failed", e), 
        this.form && this.getSearchQuery() && this.form.submit());
      }
      performSearchDebounced(t = null) {
        this.clearTimeout();
        const s = this.getSearchQuery(), i = e.DEBOUNCE_DELAY;
        this.timeout = s ? setTimeout(() => this.performSearch(t), i) : setTimeout(() => this.restoreOriginalElements(), i);
      }
      performSearchImmediate(e = null) {
        this.clearTimeout(), this.getSearchQuery() && this.performSearch(e), this.input?.blur();
      }
      attachSuggestionListeners() {
        this.querySelectorAll("[data-suggestion]").forEach(e => {
          const t = e.cloneNode(!0);
          e.parentNode?.replaceChild(t, e), t.addEventListener("click", e => {
            e.preventDefault();
            const s = t.textContent?.trim();
            s && this.form?.q && (this.form.q.value = s, this.performSearchImmediate());
          });
        });
      }
      reset() {
        this.form?.reset(), this.restoreOriginalElements(), this.updateClearButtonVisibility(), 
        this.clearTimeout(), this.abortController && (this.abortController.abort(), this.abortController = null);
      }
      cacheOriginalElements() {
        e.SELECTORS.forEach(e => {
          const t = this.querySelector(e);
          t && this.originalElements.set(e, t.cloneNode(!0));
        });
      }
      restoreOriginalElements() {
        e.SELECTORS.forEach(e => {
          const t = this.querySelector(e), s = this.originalElements.get(e);
          t && s && (t.innerHTML = s.innerHTML, "[data-suggestions]" === e && this.attachSuggestionListeners());
        });
      }
      clearTimeout() {
        this.timeout && (clearTimeout(this.timeout), this.timeout = null);
      }
      setupLoadingSpinnerReset() {
        if (!this.toggle) return;
        const e = window.matchMedia("(min-width: 1024px)"), t = () => {
          if (this.toggle.checked) if (e.matches) {
            const e = this.querySelector("[data-drawer]"), t = e?.offsetWidth || 0;
            document.dispatchEvent(new CustomEvent("global-ui:bottom-right-nudge", {
              detail: {
                source: "search-drawer",
                transform: `translateX(-${t}px)`
              }
            }));
          } else document.dispatchEvent(new CustomEvent("global-ui:bottom-right-nudge", {
            detail: {
              source: "search-drawer",
              transform: "RESET"
            }
          })); else document.dispatchEvent(new CustomEvent("global-ui:bottom-right-nudge", {
            detail: {
              source: "search-drawer",
              transform: ""
            }
          }));
        }, s = () => {
          setTimeout(() => {
            t();
          }, 10);
        }, i = () => {
          this.toggle.checked && t();
        };
        this.toggle.addEventListener("change", s), e.addEventListener("change", i), this._cleanupSpinnerReset = () => {
          this.toggle.removeEventListener("change", s), e.removeEventListener("change", i);
        };
      }
      init() {
        this.cacheOriginalElements(), this.attachSuggestionListeners(), this.updateClearButtonVisibility();
      }
      disconnectedCallback() {
        this.reset(), this.toggle?.removeEventListener("change", this.handleToggle), this.form?.removeEventListener("reset", this.handleFormReset), 
        this.form?.removeEventListener("submit", this.handleFormSubmit), this.input?.removeEventListener("input", this.handleInput), 
        this.input?.removeEventListener("focus", this.handleFocus), this.input?.removeEventListener("blur", this.handleBlur), 
        this.clearButtons?.forEach(e => {
          e.removeEventListener("click", this.handleClear);
        }), this._cleanupSpinnerReset && this._cleanupSpinnerReset();
      }
    }
    customElements.define("search-drawer", e);
  }
})();